import { crashApiGet } from './crash-api';
import { mapCrashPreGame } from './crash-pre-game.mappers';
import type {
  ApiFetchCrashPreGameParams,
  ApiFetchCrashPreGamePort,
} from '~/handlers/ports/api-fetch-crash-pre-game.port';
import type { CrashPreGame } from '~/types/crash-pre-game';

export class ApostatudoApiFetchCrashPreGameAdapter
  implements ApiFetchCrashPreGamePort
{
  async handle({
    gameName,
    signal,
  }: ApiFetchCrashPreGameParams): Promise<CrashPreGame> {
    const json = await crashApiGet(
      `/crash/pre-game?game_name=${encodeURIComponent(gameName)}`,
      { signal },
    );

    return mapCrashPreGame(json);
  }
}
